export const mapLocationGeoToLocationType = (types) => {
  if (types.includes('country')) {
    return 'Country'
  }

  if (types.includes('locality')) {
    return 'City'
  }

  if (
    types.includes('administrative_area_level_1') ||
    types.includes('colloquial_area') ||
    types.includes('political')
  ) {
    return 'Region'
  }

  if (types.includes('continent')) {
    return 'Continent'
  }
}
